import { render, staticRenderFns } from "./contactUsPage.vue?vue&type=template&id=3513c979&scoped=true"
import script from "./contactUsPage.vue?vue&type=script&lang=js"
export * from "./contactUsPage.vue?vue&type=script&lang=js"
import style0 from "./contactUsPage.vue?vue&type=style&index=0&id=3513c979&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3513c979",
  null
  
)

export default component.exports